import React from 'react'

type ProductPageShellProps = {
	navClassName?: string
	navBackgroundClassName?: string
	navBorderClassName?: string
	navContent: React.ReactNode
	backgroundClassName?: string
	mainContainerClassName?: string
	mainContainerStyle?: React.CSSProperties
	mainContent: React.ReactNode
	children?: React.ReactNode
}

const ProductPageShell: React.FC<ProductPageShellProps> = ({
	navClassName = '',
	navBackgroundClassName = 'bg-white',
	navBorderClassName = 'border-grey',
	navContent,
	backgroundClassName = '',
	mainContainerClassName = '',
	mainContainerStyle,
	mainContent,
	children
}) => {
	return (
		<div className="shop-animation-container">
			<div className={`nav-section w-full sticky -top-[30px] -mt-[30px] z-40 ${navBackgroundClassName} ${navClassName}`}>
				<div className="transition-all">
					<div className={`h-[100px] w-full ${navBackgroundClassName} border-b-[2px] ${navBorderClassName} flex justify-center pt-[30px]`}>
						{navContent}
					</div>
				</div>
			</div>

			<div className={backgroundClassName}>
				<div className="shop-container flex flex-col items-center pb-4">
					<div
						className={`main-container standard_container gap-0 ${mainContainerClassName}`}
						style={mainContainerStyle}
					>
						{mainContent}
					</div>
				</div>
			</div>

			{children}
		</div>
	)
}

export default ProductPageShell
